module.exports = __webpack_public_path__ + "static/media/customer-zydus.png.01a8594e.png";